module.exports = __webpack_public_path__ + "static/media/eolica_banner.39d87cd2.png";